exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".row__2En7x{margin-bottom:.5em}.row__2En7x:last-child{margin-bottom:0}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/form-row/C:/dev/globalTopBar/src/components/common/form-row/C:/dev/globalTopBar/src/components/common/form-row/styles.scss"],"names":[],"mappings":"AAAA,YACE,kBAAmB,CADrB,uBAII,eAAgB,CACjB","file":"styles.scss","sourcesContent":[".row {\n  margin-bottom: .5em;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"row": "row__2En7x"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/common/form-row/styles.scss
// module id = IBtt
// module chunks = 0